import { useClient } from '@composables/use-clients';
import {
  PostRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type AgentChatPayloadType = Record<string, never>;

type PostAgentChatArgsType = PostRequestArgsType<AgentChatPayloadType>;

export const apiCreateAgentChat = async ({
  domain = useTenantStore().domain,
  payload,
  errorConfig = {},
  callbacks = {},
}: PostAgentChatArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.agentChats({ domain }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
